import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutlined'
import RefreshIcon from '@mui/icons-material/Refresh'
import WarningIcon from '@mui/icons-material/Warning'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'

import { useAuthenticatedUser } from '../../auth/hooks/useAuthenticatedUser'
import type { Styles } from '../../theme/types/Styles'

export { PlanningsverschilIcon, tooltipsByContext }

const tooltipsByContext = {
  bijlage: {
    geen: 'De planning van deze bijlage volgt het proces',
    wijziging: 'Het proces is aangepast, deze bijlage wordt aangepast',
    afwijking:
      'Deze bijlage is handmatig aangemaakt en week bij het aanmaken af van het proces',
  },
  project: {
    wijziging: 'Dit project wordt geraakt door een of meer proceswijzigingen',
    afwijking:
      'Dit project bevat één of meer bijlagen die handmatig zijn aangemaakt en afwijken van het proces',
  },
} as const

const iconConfig = {
  geen: {
    Icon: CheckCircleOutlineIcon,
  },
  wijziging: {
    Icon: RefreshIcon,
  },
  afwijking: {
    Icon: WarningIcon,
  },
} as const

type Props = {
  sx?: Styles
  planningsverschil: string
  context?: 'bijlage' | 'project'
}

function PlanningsverschilIcon({
  sx,
  planningsverschil,
  context = 'bijlage',
}: Props) {
  const { canViewPlanningsverschil } = useAuthenticatedUser()

  if (planningsverschil in iconConfig === false) {
    return null
  }

  if (!canViewPlanningsverschil && planningsverschil !== 'afwijking') {
    return null
  }

  const config = iconConfig[planningsverschil as keyof typeof iconConfig]
  const title =
    tooltipsByContext[context][planningsverschil as keyof typeof iconConfig]

  return (
    <Tooltip title={title}>
      <IconButton sx={{ cursor: 'help', ...sx }}>
        <config.Icon />
      </IconButton>
    </Tooltip>
  )
}
